import { AuthCtx } from "./AuthCtx.ts";
import { useAuth0 } from "@auth0/auth0-react";
import { PropsWithChildren } from "react";

export function AuthCtxProvider({ children }: PropsWithChildren) {
  const { isLoading, isAuthenticated, user, logout } = useAuth0();

  return (
    <AuthCtx.Provider
      value={{
        isAuthenticated,
        isLoading,
        user,
        logout,
      }}
    >
      {children}
    </AuthCtx.Provider>
  );
}
